import { gql } from 'apollo-angular';
export const ROLES_QUERY = gql`
  query Roles {
    roles {
      id
      slug
    }
  }
`;
